import _ from 'lodash'
import dayjs from 'dayjs'

// const getMedsPerDay = (emarRoundsDetails) => {
//     let medsPerDay = 0

//     _.forEach(emarRoundsDetails, (entry) => {
//         if (isNaN(entry.dose)) return false

//         medsPerDay += entry.altDose ? _.toNumber(entry.altDose) : _.toNumber(entry.dose)
//     })

//     return medsPerDay
// }
/*
Returns the number of meds given in a week. If
the med repeats less frequently, e.g. every two weeks,
it'll return the number needed for one repetition.

E.g.
medsPerDay = 2
medication = {
    freqInterval: 2,
    freqUnit: 'week'
}

getMedsPerWeek returns 2

*/
// const getMedsPerWeek = (props) => {
//     const {
//         medsPerDay,
//         medication: { freqDaysInWeek, freqInterval, freqUnit }
//     } = props

//     if (freqUnit === 'day') {
//         const timesTakenInWeek = Math.ceil(7 / freqInterval)

//         return timesTakenInWeek * medsPerDay
//     } else if (freqDaysInWeek && freqDaysInWeek.length) {
//         return freqDaysInWeek.length * medsPerDay
//     } else {
//         return medsPerDay
//     }
// }

// const getDiscreteAlertStatus = (props) => {
//     const { log, medication } = props
//     const { emarRoundsDetails } = medication
//     const actualStock = log.amount1
//     const expectedStock = log.amount2

//     const medsPerDay = getMedsPerDay(emarRoundsDetails)
//     const medsPerWeek = getMedsPerWeek({ ...props, medsPerDay })

//     return expectedStock
//         ? expectedStock <= medsPerWeek
//         : actualStock
//             ? actualStock <= medsPerWeek
//             : false // what do we want default to be?
// }

/**
Returns whether or not to show a stock level alert.

@param {object} medication. A medication object. Will
contain the latest stock log.
*/

export const getShowAlert = (medication) => {
  const { stockAlertLevel, stockLog } = medication

  const actualStock = stockLog && stockLog.amount1
  const expectedStock = stockLog && stockLog.amount2

  const showAlert = (actualStock || expectedStock) <= stockAlertLevel

  return showAlert
}

export const getStockText = (props) => {
  const { medication } = props
  const { quantityType, stockQuantityType, stockLog } = medication
  if (!stockLog) return null
  const actualStock = stockLog.amount1
  const expectedStock = stockLog.amount2

  const unit = stockQuantityType
    ? stockQuantityType
    : quantityType
    ? quantityType
    : null
  const hasActualStock = _.isNumber(actualStock)
  const stockCount = hasActualStock ? actualStock : expectedStock
  if (stockCount === 0) return 'Out of stock'
  return `${stockCount} ${unit ? `${unit} ` : ' '}left`
}

export const getSubLabel = (log) => {
  if (!log || !log?.loggedBy) return null
  const formattedTimestamp = dayjs(log.timeLogged).format('DD-MM-YYYY • HH:mm')
  return `Updated ${formattedTimestamp} • ${log?.loggedBy.name.first} ${log?.loggedBy.name.last}`
}
